import {
  ToastCheckSuccessIcon,
  ToastCheckDoneIcon,
  ToastErrorIcon,
  ToastDeleteIcon,
  RestoreIcon,
  CopyIcon,
} from "../../icons";
import { ToastKind, ToastKindType } from "../../types/toast";

export const ToastIcon = ({ type }: { type: ToastKindType }) => {
  const toastTypeToIcon = {
    [ToastKind.SUCCESS]: ToastCheckSuccessIcon,
    [ToastKind.DONE]: ToastCheckDoneIcon,
    [ToastKind.ERROR]: ToastErrorIcon,
    [ToastKind.DELETE]: ToastDeleteIcon,
    [ToastKind.RESTORE]: RestoreIcon,
    [ToastKind.COPY]: CopyIcon,
  };

  const Icon = toastTypeToIcon[type];
  return Icon ? <Icon /> : null;
};
